// Only once, pick the best matching video uris fast without Alpine
document.querySelectorAll('.video__player').forEach(function (el) {
    const data = el.getAttribute('data-video-uris');
    if (!data) {
        return;
    }
    const videos = JSON.parse(data);
    const picks = window.innerWidth < 1366 ? videos.uris1366 : videos.uris1920;
    el.innerHTML = picks
        .map((uri) => `<source src="${uri}" type="${uri.endsWith('.mp4') ? 'video/mp4' : 'video/webm'}">`)
        .join('');
});
